/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowUpArrowDownV: {
  name: 'arrow-up-arrow-down-v';
  data: string;
} = {
  name: 'arrow-up-arrow-down-v',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.354.646a.5.5 0 0 0-.708 0l-2 2a.5.5 0 1 0 .708.708L3.5 2.207V15a.5.5 0 0 0 1 0V2.207l1.146 1.147a.5.5 0 1 0 .708-.708l-2-2ZM12.5 1a.5.5 0 0 0-1 0v12.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 2a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L12.5 13.793V1Z" fill="currentColor"/></svg>`,
};
